// extracted by mini-css-extract-plugin
export default {"statConn":"Doughnut_statConn__2BtZK","containerConn":"Doughnut_containerConn__PY1Xl"};